import {disableGeoSearch, iOS, translate} from "./utils.esm";
import {autocompleteFn} from "./autocomplete-fn";

window.autocompleteFn = autocompleteFn;
export default class SearchAutocomplete {
    constructor(containerSelector, selector) {
        console.log('init SearchAutocomplete Component');

        this.selector = selector;
        this.baseContainer = document.querySelector(containerSelector);
        this.el = this.baseContainer.querySelector(selector);

        // TODO provoca CLS checkear
        // this.homeLastSearchForm = window.localStorage.getItem('home_last_search_form');
        // this.homeLastSearchFormCity = window.localStorage.getItem('home_last_visited_city');
        // const container = this.baseContainer.querySelector('.main-search-container');
        // if(container && this.homeLastSearchForm && this.homeLastSearchFormCity) {
        //     const containerLastCity = container.querySelector('.main-search-last');
        //     container.parentElement.classList.add('show-last');
        //     container.classList.add('show-last');
        //     containerLastCity.addEventListener('click', () => submitLastSearchForm('home_last_search_form'));
        //     containerLastCity.querySelector('.home-last-city').innerHTML = this.homeLastSearchFormCity;
        // }

        this.el.addEventListener('focusin', (event) => this.homeAutocompleteFocusHandler(event, this.el.parentElement.parentElement, selector));
        this.el.addEventListener('click', (event) => this.fixHomeAutocompleteFocusout(event));
        this.el.addEventListener('keyup', (event) => this.homeAutocompleteKeyUpHandler(event, this.el));
        if(iOS()) this.el.addEventListener('blur', () => setTimeout(autocompleteFn.hideHomeAutocomplete, 0));

        this.baseContainer.addEventListener('click', () => autocompleteFn.hideHomeAutocomplete(this.baseContainer));
    }

    homeAutocompleteKeyUpHandler(event) {
        const value = this.el.value;
        const isEnterKey = event ? event.keyCode === 13 : false;

        disableGeoSearch();

        if(isEnterKey || value.length <= 2) return;

        // if(value.length === 0 && isEnterKey) {
        //     autocompleteFn.showHomeSearchMapInputError();
        //     return false;
        // }
        // else if(isEnterKey) {
        //     autocompleteFn.simulateHomeAutocompleteItemClickHandler(event, autocompleteFn.homeAutocompleteItems);
        //     return false;
        // }

        autocompleteFn.hideHomeSearchMapInputError();

        fetch(window.HTML_ROOT + '/city-and-area-counts?q=' + value).then(response => response.json().then(body => {
            autocompleteFn.homeAutocompleteItems = Array.from(body);
            autocompleteFn.fillHomeAutocomplete(autocompleteFn.homeAutocompleteItems, value).then((autocomplete) => this.generateHTMLHomeAutocomplete(autocomplete));
        }));
    }

    async homeAutocompleteFocusHandler(event, baseContainer, selector) {
        event.preventDefault();
        event.stopPropagation();

        if(document.querySelector('.home-autocomplete')) this.showHomeAutocomplete(baseContainer);
        else await this.generateHomeAutocomplete(baseContainer, selector);
    }

    fixHomeAutocompleteFocusout(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    showHomeAutocomplete() {
        document.querySelectorAll('.home-autocomplete')
            .forEach(element => element.classList.remove('d-none'));
    }

    async generateHomeAutocomplete(baseContainer, selector) {
        autocompleteFn.hideHomeAutocomplete(baseContainer);
        const autocomplete = document.createElement('div');
        const container = baseContainer.querySelector('.main-search-input');
        autocomplete.classList.add('home-autocomplete');
        const div = document.createElement('div');
        div.innerHTML = `
            <div class="autocomplete-nearby">
                <img src="/img/icons/ic_my_location.svg" alt="my-location" />
                <span class="autocomplete-nearby-label"></span>
            </div>
        `;
        div.querySelector('.autocomplete-nearby').onclick = () => autocompleteFn.homeNearByBtn(selector);
        const div2 = document.createElement('div');
        div2.innerHTML += `
            <div class="autocomplete-no-results">
                <img src="/img/icons/marker-home.svg" alt="marker-home" />
                <span class="autocomplete-no-results-label"></span>
            </div>
        `;
        autocomplete.append(div, div2);

        translate({
            str: 'Pesquisar perto de ti',
            element: div.querySelector('.autocomplete-nearby-label')
        });

        translate({
            str: 'Nenhum resultado encontrado',
            element: div2.querySelector('.autocomplete-no-results-label')
        });

        this.homeAutocompleteKeyUpHandler(undefined, container.querySelector('input'));

        container.appendChild(autocomplete);

        baseContainer.querySelector('.home-autocomplete').classList.add('show-nearby');
    }

    generateHTMLHomeAutocomplete(autocomplete) {
        autocompleteFn.homeAutocompleteItems.forEach(item => {
            const div = document.createElement('div');
            div.innerHTML = '<div class="autocomplete-item" data-type="'+ item.type +'" data-id="'+ item.id +'"><div><img src="/img/icons/marker-home.svg" alt="marker-home" />'+ item.text +'</div>'+ item.count +'</div>';
            // noinspection JSDeprecatedSymbols
            div.querySelector('.autocomplete-item[data-type="'+item.type+'"][data-id="'+item.id+'"]').onclick = () => autocompleteFn.homeAutocompleteItemClickHandler(event, item.text, item.type, item.id, this.baseContainer);
            autocomplete.append(div);
        });
        this.showHomeAutocomplete();
    }

}